var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtxCuttedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 132,
    viewBox: "0 0 119 132",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.917 2.3405L115.497 38.7865C119.939 42.053 119.707 47.5631 114.977 51.0387L66.4369 86.7218C61.7067 90.1974 54.2129 90.3669 49.7653 87.1004L0.1854 50.6544C-4.25661 47.3879 -4.0249 41.8778 0.70533 38.4022L49.2453 2.7248C53.9756 -0.750819 61.475 -0.926013 65.917 2.3405ZM60.6273 74.2152L79.5256 60.324C82.0574 58.459 82.0574 55.5938 79.5256 53.7288C76.8186 51.7395 72.354 51.7395 69.6526 53.7288L57.8411 62.4094L33.7661 44.7148L57.8411 27.0146L69.6526 35.6951C72.3596 37.6844 76.8242 37.6844 79.5256 35.6951C82.0631 33.8302 82.0631 30.9649 79.5256 29.1056L60.6273 15.2257C59.1127 14.1181 56.5639 14.1181 55.055 15.2257L17.2583 43.0024C15.9189 43.9858 15.9189 45.4495 17.2583 46.4328L55.0493 74.2152C56.5639 75.3229 59.1183 75.3229 60.6273 74.2152ZM86.3977 41.4257C83.8659 43.2906 83.8659 46.1503 86.3977 48.0152C89.1047 50.0045 93.5694 50.0045 96.2707 48.0152C98.8026 46.1503 98.8026 43.285 96.2707 41.4257C93.5694 39.4364 89.1047 39.4364 86.3977 41.4257Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49271 70.2761L0.80084 63.8844L0.704766 63.9522C-4.01982 67.4278 -4.25718 72.9436 0.184836 76.2045L0.80084 76.6566L9.49271 83.0427L49.7647 112.645C54.2067 115.911 61.7061 115.736 66.4364 112.26L106.188 83.0427L114.88 76.6622L114.976 76.5944C119.707 73.1188 119.938 67.603 115.496 64.3365L114.88 63.8844L106.188 70.2761L97.4965 76.6622L66.4364 99.4939C61.7061 102.97 54.2067 103.139 49.7647 99.8726L18.1846 76.6622L9.49271 70.2761Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7647 125.434L0.80084 89.4457L0.704766 89.5135C-4.01982 92.9891 -4.25718 98.5049 0.184836 101.766L49.7647 138.206C54.2067 141.473 61.7061 141.297 66.4364 137.822L114.976 102.144C119.707 98.6688 119.938 93.1587 115.496 89.8922L114.88 89.4401L66.4364 125.05C61.7118 128.525 54.2067 128.695 49.7647 125.434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtxCuttedLogo);
export default __webpack_public_path__ + "static/media/ctx_cutted_logo.1ffa031b881d7d8b99a01c7527129f1e.svg";
export { ForwardRef as ReactComponent };